// 文章详情页，商城详情页，产品详情页，侧边栏固定推荐位
var fixedSidebar = {

    //滚动条初始化
    initScrollBar: function () {
        $(".fixed-sidebar").niceScroll({
            cursorcolor: "#007db8",
            cursoropacitymin: 0,
            cursoropacitymax: 0.5,
            cursormaxheight: 200,
            hwacceleration: true,
            autohidemode: 'leave'
        });
    },

    getHeight: function () {
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        this.setHeight(windowHeight);
        this.initScrollBar();
        var _this = this;
        window.addEventListener("resize", function () {
            windowHeight = window.innerHeight || document.documentElement.clientHeight;
            _this.setHeight(windowHeight);
            _this.scrollBarResize();
        }, false);
    },

    // 计算版权部分的高度，控制推荐位的显隐
    getScroolTop: function () {
        var _this = this;
        window.addEventListener('scroll', function () {
            var distance = document.querySelector('.footerWra').getBoundingClientRect().bottom;
            if (distance < 0) {
                document.querySelector('.fixed-sidebar').classList.remove('fixed-sidebar-top');
            } else {
                document.querySelector('.fixed-sidebar').classList.add('fixed-sidebar-top');
                _this.scrollBarResize();
            }
        })
    },

    scrollBarResize: function () {
        setTimeout(function () {
            $(".fixed-sidebar").getNiceScroll().resize();
        }, 1200)
    },

    // 设置推荐位的高度
    setHeight: function (h) {
        document.querySelector('.fixed-sidebar').style.height = h - 70 + 'px'; //70 为顶部固定bar的高度
    },


    //根据栏目设置top
    setTop: function () {
        // 商城详情
        if (cateData.pageModule === 'shopDetail') {
            document.querySelector('.fixed-sidebar').classList.add('fixed-sidebar-t50');
        }

        // 产品详情
        if (cateData.pageModule === 'productDetail') {
            document.querySelector('.fixed-sidebar').classList.add('fixed-sidebar-t30');
        }
    },


    //展示项目咨询单带产品信息
    showProjectConsultingModal: function (urlData) {
        event.stopPropagation();
        var formConfig = window.cateData.purchaseIntentionForm;
        formConfig.entrance = urlData ? urlData.entrance : '';
        gio('track', 'buysubmitclick_product', {
            'ibuyEntrancePageTitle': document.title,
            'ibuyEntrancePageURL': document.URL
        });  //埋点实施方案
        msg.bargainDialog(urlData, formConfig);
    },

    init: function () {
        if ($(".fixed-sidebar").length === 0) {
            return;
        }
        this.setTop();
        this.getHeight();
        this.getScroolTop();
    }

};

fixedSidebar.init();
